import instance from "../instance";

export const userApi = {
  createProfile: () => {
    return instance.post(`/v1/profiles`, {title: ''})
  },
  getProfile: (id) => {
    return instance.get(`/v1/profiles/${id}`)
  },
  getCurrentUser: async () => {
    ///v1/users/me
    return instance.get('/v1/users/me')
  },
  updateProfile: (id, first_name, last_name, phone_number, birth_date) => {
    return instance.patch(`/v1/profiles/${id}`, {
      first_name,
      last_name,
      phone_number: phone_number?.split(" ").join("") ?? '',
      birth_date
    })
  },
  recoveryPassword: (email) => {
    return instance.post(`/v1/password-recovery/${email}`, {email}, {
      headers: {
        accept: 'application/x-www-form-urlencoded',
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  resetPassword: (token, new_password) => instance.post('/v1/reset-password', {token, new_password}),
  uploadFile: (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return instance.post(`/v1/storage/upload?public=true`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  getFile: (id) => instance.get(`/v1/storage/download/${id}`, {responseType: 'arraybuffer'}),
  getFileInfo: (id) => instance.get(`/v1/storage/files/${id}`),
  uploadAvatar: (profileId, fileId) => instance.patch(`/v1/profiles/${profileId}`, {image_link: fileId}),
  sendConfirmEmail: (profileId, email) => instance.post(`/v1/profiles/${profileId}/send-confirm?email=${email}`),
  deleteProfile: (id) => instance.delete(`/v1/profiles/${id}`)
}
